// 캐릭터 머티리얼: 프레넬 림 발광(상시, ART-BIBLE 3장) + 반전 헐 외곽선. TSL 노드라 WebGPU·WebGL2에서 같은 코드로 돈다.
import * as THREE from 'three/webgpu';
import { float, materialEmissive, normalLocal, normalView, positionLocal, positionViewDirection, uniform } from 'three/tsl';

/** 림 색·세기 uniform. 개체(영웅·보스)마다 하나씩 두고 머티리얼이 공유한다. */
export class RimControl {
  readonly color = uniform(new THREE.Color());
  readonly strength = uniform(0);
  constructor(hex: number, strength: number) {
    this.color.value.setHex(hex);
    this.strength.value = strength;
  }
}

/** 발광을 바꿀 수 있는 머티리얼(표준·노드 공통) */
export interface EmissiveMat {
  emissive: THREE.Color;
  emissiveIntensity: number;
  dispose(): void;
}

export interface CharMatOptions {
  roughness?: number;
  metalness?: number;
  vertexColors?: boolean;
}

/** 림 발광 캐릭터 머티리얼. 피격·각성 발광은 emissive(materialEmissive)로 그대로 쓴다. */
export function charMaterial(color: number, rim: RimControl, opts: CharMatOptions = {}): THREE.MeshStandardNodeMaterial {
  const m = new THREE.MeshStandardNodeMaterial({
    color,
    roughness: opts.roughness ?? 0.62,
    metalness: opts.metalness ?? 0.05,
    vertexColors: opts.vertexColors === true,
  });
  m.emissive = new THREE.Color(0x000000);
  const fres = float(1).sub(normalView.dot(positionViewDirection).clamp(0, 1)).pow(3);
  m.emissiveNode = materialEmissive.add(rim.color.mul(fres).mul(rim.strength));
  return m;
}

/** 반전 헐 외곽선: 법선 방향으로 부풀린 뒷면만 그린다(화면 1~2px 상당). */
export function hullMaterial(thickness: number, color = 0x0b0f1c): THREE.MeshBasicNodeMaterial {
  const m = new THREE.MeshBasicNodeMaterial({ color, side: THREE.BackSide });
  m.positionNode = positionLocal.add(normalLocal.mul(thickness));
  return m;
}

/** mesh의 자식으로 같은 지오메트리의 외곽선을 단다(변환을 그대로 따라간다). */
export function addHull(mesh: THREE.Mesh, mat: THREE.Material): THREE.Mesh {
  const h = new THREE.Mesh(mesh.geometry, mat);
  h.castShadow = false;
  h.receiveShadow = false;
  mesh.add(h);
  return h;
}

/** 여러 머티리얼의 발광을 한 번에 바꾼다(피격 흰 플래시, 각성 붉은 발광). */
export function setEmissive(mats: readonly EmissiveMat[], hex: number, intensity: number): void {
  for (let i = 0; i < mats.length; i++) {
    mats[i].emissive.setHex(hex);
    mats[i].emissiveIntensity = intensity;
  }
}
